import { render, staticRenderFns } from "./AdvertBanner.vue?vue&type=template&id=3b374eeb&scoped=true&"
import script from "./AdvertBanner.vue?vue&type=script&lang=js&"
export * from "./AdvertBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdvertBanner.vue?vue&type=style&index=0&id=3b374eeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b374eeb",
  null
  
)

export default component.exports